import React from 'react';
import { TextInput, TextInputProps, StyleSheet } from 'react-native';
import { colors, fonts, radii, spacing } from '../theme';

export function TextField({ style, ...rest }: TextInputProps) {
  return <TextInput placeholderTextColor={colors.thread} style={[styles.input, style]} {...rest} />;
}

const styles = StyleSheet.create({
  input: {
    backgroundColor: colors.sandPanel,
    borderRadius: radii.md,
    paddingVertical: 14,
    paddingHorizontal: spacing.md,
    marginBottom: spacing.sm,
    fontFamily: fonts.body,
    fontSize: 16,
    color: colors.ink,
  },
});
